module.exports = {"id":"228702","name":"Frenkie de Jong","rating":"75","photo":"./data/images/photos/4/228702.png","club":{"name":"Ajax","logo":"./data/images/clubs/Ajax.png"},"positions":["MC","MDC","DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FrenkiedeJong0.json
// module id = 1504
// module chunks = 0